import { Card, CardBody, Col } from "reactstrap";
import { Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { NestedSwiperTitle } from "../../../Constants/Constants";
import { NestedSwiperData, NestedSwiperSubTitle } from "../../../Data/BonusUi/Carousel";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

const NestedSwiper = () => {
  return (
    <Col xl="6" xs="12">
      <Card>
        <CommonCardHeader title={NestedSwiperTitle} span={NestedSwiperSubTitle} />
        <CardBody>
          <Swiper className="mySwiper swiper-h" spaceBetween={50} pagination={{ clickable: true }} modules={[Pagination]}>
            <SwiperSlide>
              <Image src={dynamicImage(`slider/7.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
            </SwiperSlide>
            <SwiperSlide>
              <Swiper className="mySwiper2 swiper-v" direction={"vertical"} spaceBetween={50} pagination={{ clickable: true }} modules={[Pagination]}>
                {NestedSwiperData.map((item, index) => (
                  <SwiperSlide key={index}>
                    <Image src={dynamicImage(`slider/${item}.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
                  </SwiperSlide>
                ))}
              </Swiper>
            </SwiperSlide>
            <SwiperSlide>
              <Image src={dynamicImage(`slider/3.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
            </SwiperSlide>
            <SwiperSlide>
              <Image src={dynamicImage(`slider/4.jpg`)} className="d-block w-100" alt="Vertical_Slider" />
            </SwiperSlide>
          </Swiper>
        </CardBody>
      </Card>
    </Col>
  );
};

export default NestedSwiper;
